import { CommonModule, Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { permissions, clearPermissions } from '../../../config/permissions';
import { ToastMessageComponent } from 'src/app/common/toast-message/toast-message.component';
import { UserService } from 'src/app/home/services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EditRoleConfirmationComponent } from '../../modals/edit-role-confirmation/edit-role-confirmation.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-add-role',
  standalone: true,
  imports: [CommonModule, FormsModule, ToastMessageComponent],
  templateUrl: './add-role.component.html',
  styleUrls: ['./add-role.component.scss', '../../../app.component.scss']
})
export class AddRoleComponent implements OnInit{
  @ViewChild(ToastMessageComponent) toastMessage: ToastMessageComponent;
  public permissions = permissions;
  public currentRoleId: string;
  public currentType: string;

  public role = {
    name: "",
    resource_id: null,
    web_permissions: null,
    hardware_permissions: null,
  }

  public isHardwarePermissions = false;

  constructor(
    public location: Location, 
    public userService: UserService, 
    private router: Router,
    private activatedRoute: ActivatedRoute, 
    public dialog: MatDialog
  ) {
    this.role.resource_id = JSON.parse(localStorage.getItem('role')).resource_id
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(routeParam => {
      this.currentRoleId = routeParam.id;
      this.currentType = routeParam.type;

      clearPermissions('web');
      clearPermissions('hardware');

      if (this.currentType === 'edit') {
        this.getRoleDetails(Number(this.currentRoleId));
      }
    });

  }

  addOrEditRole(formData){
    let webPermissions = this.permissions.web.groups
                          .flatMap(group => group.permissions.filter(permission => permission.isChecked))
                          .map(permission => permission.u_name);

    let hardwarePermissions = this.permissions.hardware.groups
                          .flatMap(group => group.permissions.filter(permission => permission.isChecked))
                          .map(permission => permission.u_name);

    if (hardwarePermissions.length === 0 && webPermissions.length === 0) {
      return this.toastMessage.showToast("Please select any of the permissions below for adding a new role", "error", 5000);
    }

    this.role.name = formData.role_name.toLowerCase();
    this.role.web_permissions = webPermissions;
    this.role.hardware_permissions = hardwarePermissions;

    if (this.currentType === 'edit') { 
      this.userService.updateRoles(this.currentRoleId, this.role).subscribe({
        next: (res) => {
          if (res.data) {
            this.toastMessage.showToast("Role has been successfully updated", "success", 5000);
            // this.router.navigateByUrl(`roles?id=${this.currentRoleId}`);
            if (!this.isHardwarePermissions && res.data.is_hardware_permission) {

              this.dialog.open(EditRoleConfirmationComponent, {
                data: {
                  name: res.data.name
                }
              }).afterClosed().subscribe(result => {
                
              });      
            }else{
              this.router.navigateByUrl('roles');
            }
          }
        },
        error: (err) => {
          console.log(err);
        },
        complete: () => {
          console.log('completed');
        }
      })
    }else{
      this.userService.addRoles(this.role).subscribe({
        next: (res) => {
          if (res.data) {
            this.toastMessage.showToast("Role is successfully created", "success", 5000);
            this.router.navigateByUrl('roles');
            // this.router.navigateByUrl(`roles?id=${res.data.id}`);

          }
        },
        error: (err) => {
          if (err.status === 409) {
            this.toastMessage.showToast("Given Role name is already exists", "error", 5000);
          }
        },
        complete: () => {
          console.log('completed');
        }
      })
    }
  }

  getRoleDetails(roleId: number){
    this.userService.getRoleDetails(roleId).subscribe((res)=>{
      if (res.data) {
        let response = res.data;

        this.role.name = response.name;

        this.isHardwarePermissions = response.is_hardware_permission;
        
        if (response.web_permissions.length !== 0 ) {
          this.permissions.web.groups.forEach(group => {
            group.permissions.forEach((permission)=>{
              if (response.web_permissions.includes(permission.u_name)) {
                permission.isChecked = true
              }else{
                permission.isChecked = false
              }
            })

            group.isChecked = group.permissions.some((permission) => permission.isChecked);
          });
        }

        if (response.hardware_permissions.length !==0 ) {
          this.permissions.hardware.groups.forEach(group => {
            group.permissions.forEach((permission)=>{
              if (response.hardware_permissions.includes(permission.u_name)) {
                permission.isChecked = true
              }else{
                permission.isChecked = false
              }
            })

            group.isChecked = group.permissions.some((permission) => permission.isChecked);
          });
        }
      }
    })
  }

  onTabClick(event: any, tabId: string){

    let accordionBtn = event.target.closest('.accordion-btn');

    accordionBtn.querySelector('.accordion-collapse').classList.toggle('d-none');
    accordionBtn.querySelector('.accordion-expand').classList.toggle('d-none');

    let currentTabContent = document.getElementById(tabId);

    currentTabContent.classList.toggle('current');
  }

  onGroupPermissionChecked(event: any, i: number, type: string){
    this.permissions[type].groups[i].permissions.forEach((el) => {
      el.isChecked = event.target.checked
    });
  }

  onPermissionChecked(event: any, i: number, type: string){
    let permissionGroup = this.permissions[type].groups[i];
    permissionGroup.isChecked = permissionGroup.permissions.some((permission) => permission.isChecked);
  }

  goBack(){
    // if (this.currentType === 'edit') {
    //   return this.router.navigateByUrl(`roles?id=${this.currentRoleId}`);
    // }
    this.location.back();
  }

  goBackWithConfirmation(){
    let isConfirmed = confirm('Do you want to discard your changes');
    if (isConfirmed) {
      // if (this.currentType === 'edit') {
      //   return this.router.navigateByUrl(`roles?id=${this.currentRoleId}`);
      // }
      this.location.back();
    }
  }
}
